import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Detail page header: back + actions row, then an identity card
 * (ref / chip / title / meta on the left, status pills on the right).
 */
@Component({
  selector: 'app-detail-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="pp-dh" [class.pp-dh--compact]="compact">
      <div class="pp-dh__top">
        <button *ngIf="showBack" type="button" class="pp-btn pp-dh__back" (click)="back.emit()">
          <i class="pi pi-arrow-left"></i>
          {{ backLabel }}
        </button>
        <div class="pp-dh__actions">
          <ng-content select="[detailActions]"></ng-content>
        </div>
      </div>

      <header class="pp-dh__card">
        <ng-container *ngIf="!loading; else skeleton">
          <span *ngIf="avatar || avatarText" class="pp-dh__avatar">
            <img *ngIf="avatar; else initials" [src]="avatar" alt="" />
            <ng-template #initials>{{ avatarText }}</ng-template>
          </span>
          <div class="pp-dh__identity">
            <div class="pp-dh__eyebrow">
              <span *ngIf="refNo" class="pp-dh__ref">{{ refNo }}</span>
              <span *ngIf="chip" class="pp-chip" [ngClass]="chipTone ? 'pp-chip--' + chipTone : ''">{{ chip }}</span>
              <ng-content select="[detailEyebrow]"></ng-content>
            </div>
            <h1 class="pp-dh__title">{{ heading || '—' }}</h1>
            <div class="pp-dh__meta">
              <ng-content select="[detailMeta]"></ng-content>
            </div>
          </div>
          <div class="pp-dh__status">
            <ng-content select="[detailStatus]"></ng-content>
            <ng-content select="[detailPrimary]"></ng-content>
          </div>
        </ng-container>
        <ng-template #skeleton>
          <div class="pp-dh__identity">
            <span class="pp-skel pp-skel--w25"></span>
            <span class="pp-skel pp-skel--title"></span>
            <span class="pp-skel pp-skel--w60"></span>
          </div>
        </ng-template>
      </header>
    </div>
  `,
  styles: [':host { display: block; }'],
})
export class DetailHeaderComponent {
  @Input() heading: string | null | undefined = '';
  @Input() refNo: string | null | undefined = null;
  @Input() chip: string | null | undefined = null;
  /** Matches a `.pp-chip--{tone}` modifier: lead, quote, job, invoice, client, user. */
  @Input() chipTone = '';
  @Input() avatar: string | null | undefined = null;
  @Input() avatarText: string | null | undefined = null;
  @Input() backLabel = 'Back';
  @Input() showBack = true;
  @Input() loading = false;
  @Input() compact = false;
  @Output() back = new EventEmitter<void>();
}
